import { useIO, useLinked, useModel } from "@type-r/react";
import { Loading } from "lqx-react/lib";
import React from "react";
import { AssetType } from "../../api/assetType";
import { Company } from "../../api/company";
import { ManualCustomerReferenceData } from "../../api/customerReferenceData";
import { DocumentSource } from "../../api/documentSource";
import { IngestionJob } from "../../api/ingestionJob";
import { ImportTemplatesLookup } from "../../api/lookups";
import { AddAssetsStep } from "../add-assets-step";
import { CustomerReferenceDataForm } from "./customer-reference-data-form";

export const AddCustomerReferenceDataStep = ({ next, back, cancel, job }:
    { next?, back?, cancel?, job: IngestionJob }) => {
    const assetExtensions = "*.xlsx,*.xls,*.csv";
    const userTemplates = useModel(ImportTemplatesLookup);
    const $allowedExtension = useLinked(assetExtensions);
    const $userTemplate = useLinked<{ id?: string }>(null)
        .onChange(x => applyImportTemplateExtension(x.id));
    const $dataHolderId = useLinked<Company>(new Company());
    const isReady = useIO(async () => {
        const params = { params: { assetTypeId: AssetType.customerReferenceData } }
        await userTemplates.fetch(params).catch(e => console.error(e));
    }, []);

    const applyImportTemplateExtension = (userTemplateId) => {
        let importTemplateExtension: string;
        if (Boolean(userTemplateId) && Boolean(userTemplates)) {
            const userTemplate = userTemplates.items.find((item) => item.id === userTemplateId);
            if (userTemplate) {
                importTemplateExtension = userTemplate.originalFileName.split(".").pop();
                $allowedExtension.set(`*.${importTemplateExtension}`);
            }
        } else {
            $allowedExtension.set(assetExtensions);
        }
    }
    const showDownloadTemplate = true;

    return isReady ?
        <>
            <AddAssetsStep
                assetName="Customer Reference Data"
                allowedExtension={$allowedExtension.value}
                jobInfoProvider={() => ({ ...DocumentSource.CustomerReferenceData, userTemplateId: $userTemplate.value.id, dataHolderId: Boolean($dataHolderId.value) ? $dataHolderId.value.id : null })}
                $dataHolderId={$dataHolderId}
                userTemplates={userTemplates}
                $userTemplate={$userTemplate}
                showDownloadTemplate={showDownloadTemplate}
                assetForm={crd => <CustomerReferenceDataForm crd={crd}></CustomerReferenceDataForm>}
                manualAssetModel={ManualCustomerReferenceData}
                next={next} back={back} cancel={cancel} job={job} />
        </> : <Loading />
}